import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'

import OverflowTooltip from '../../../atoms/OverflowTooltip'
import Dropdown from '../../../atoms/Dropdown'
import FieldCopy from '../FieldCopy'

import { getFilteredOptions } from '../helpers'
import useStyles from '../styles'

const CustomFieldDropDown = ({
  field,
  value,
  disabled,
  canEdit,
  handleChange,
  handleBlur,
  task,
  inputOnly,
  row,
  rowKey,
  parent,
  meta,
  shouldFilter,
  inTable
}) => {
  const theme = useTheme()

  const [glowing, setGlowing] = React.useState(false)
  const [hovering, setHovering] = React.useState(false)

  const options = React.useMemo(() => {
    if (field.options) return ['', ...(field.options ?? [])]

    const opts = field.config?.options ?? []

    if (!shouldFilter) {
      return ['', ...opts.map(opt => opt.val)]
    }

    return ['', ...getFilteredOptions(opts, meta).map(opt => opt.val)]
  }, [field, shouldFilter, meta])

  const classes = useStyles({ readOnly: disabled, task, inputOnly, inTable })

  React.useEffect(() => {
    if (!shouldFilter) return

    const hasVal = !!value
    if (hasVal && !options.includes(value)) {
      setGlowing(true)
      handleChange({ target: { value: '' } }, field, row, rowKey, parent)
      setTimeout(() => {
        handleBlur && handleBlur()
      }, 100)

      setTimeout(() => {
        setGlowing(false)
      }, 2000)
    }
  }, [
    shouldFilter,
    value,
    options,
    field,
    row,
    rowKey,
    parent,
    handleChange,
    handleBlur
  ])

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={clsx(
        classes.fieldInputRoot,
        classes.dropdownRoot,
        glowing && classes.glowRoot,
        'cf-input-root'
      )}
    >
      {!inputOnly && (
        <OverflowTooltip
          text={field.description}
          className={clsx(classes.label, 'label')}
        >
          {field.title}
        </OverflowTooltip>
      )}

      <FieldCopy
        inTable={inTable}
        visible={hovering}
        text={value}
        style={{ marginLeft: '0' }}
      />

      <Dropdown
        wrapperClass={classes.input}
        options={options}
        renderOption={val => val || 'Select'}
        selected={value}
        onSelect={opt => {
          // Only triggered when value changes to a different one than starting
          handleChange({ target: { value: opt } }, field, row, rowKey, parent)
          setTimeout(() => {
            handleBlur && handleBlur()
          }, 100)
        }}
        hideAdd
        stringOnly
        disabled={disabled || !canEdit}
        popperProps={{
          modifiers: [{ name: 'flip' }],
          placement: 'bottom-start'
        }}
      >
        <div className={classes.dropDownValue}>
          <div>
            {value || (
              <span
                style={{ color: inputOnly ? 'black' : theme.palette.textLight }}
              >
                Select
              </span>
            )}
          </div>
        </div>
      </Dropdown>
    </div>
  )
}

export default CustomFieldDropDown
